import type {commonState} from './types'

import {atom, useAtomValue} from 'jotai'

import store from '..'

const commonAtom = atom<commonState>((get) => get(store).common)

export const useCommonSelector = () => {
  const query = useAtomValue(commonAtom).query
  return {query}
}
